import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/$org/$project/pools/$name/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/$org/$project/pools/$name/$tab", params: { ...params, tab: "overview" } });
  },
});
